var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CursorsHandPointerIconInner(props) {
    return (React.createElement("svg", __assign({ width: 21, height: 23, viewBox: "0 0 21 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { filter: "url(#filter0_d_507_6433)" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 9H18V14H17V16H16V19H8V17H7V16H6V15H5V13H4V12H3V10H4V9H6V10H7V3H8V2H10V3H11V7H15V8H17V9Z", fill: "" })),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 17V18H15V16H16V14H17V9H16V10H15V8H14V9H13V8H11V9H10V3H8V12H7V11H6V10H4V12H5V13H6V15H7V16H8V17H9ZM11 12H10V15H11V12ZM12 12H13V15H12V12ZM15 13H14V15H15V13Z", fill: "white" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_507_6433", x: 0, y: 0, width: 21, height: 23, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 1 }),
                React.createElement("feGaussianBlur", { stdDeviation: 1.5 }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_507_6433" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_507_6433", result: "shape" })))));
}
export var CursorsHandPointerIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CursorsHandPointerIconInner }, props))); };
//# sourceMappingURL=CursorsHandPointerIcon.js.map